


import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // ← ADD THIS
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDfik46pPYN2UW8nK557VTAItg5e3jvW6c",
  authDomain: "showroom-2faf9.firebaseapp.com",
  projectId: "showroom-2faf9",
  storageBucket: "showroom-2faf9.firebasestorage.app",
  messagingSenderId: "465925402042",
  databaseURL: "https://showroom-2faf9-default-rtdb.asia-southeast1.firebasedatabase.app",
  appId: "1:465925402042:web:1ed14393a116c35da64183"
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app); // ← ADD THIS
export const googleProvider = new GoogleAuthProvider(); // ← ADD THIS

// Export storage instance
export const storage = getStorage(app);
export const database = getDatabase(app);

export default app;